module.exports = "/static/assets/74e1794c7821c00890a69825d7526c5e.png";